<template>
   <div class="alls">
<div class="top">
  <el-form :model="stationInfo" :rules="powerStationRules" ref="powerStationRef" label-width="100px">
        <el-form-item label="电站类别" prop="stationMode" v-if="title == '添加电站'">
          <el-radio-group v-model="stationInfo.stationMode" @change="radioelerc_change">
            <el-radio v-for="(item, index) in radioeletric" :key="index" :label="item.id">
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电站名称" prop="stationName">
          <el-input v-model="stationInfo.stationName" placeholder="请输入电站名称"></el-input>
        </el-form-item>
        <el-form-item label="电站地址" prop="address">
          <el-input v-model="stationInfo.address" placeholder="请输入电站地址"></el-input>
          <el-button style="margin-top: 5px;" size="small" @click="getMap">获取地图位置</el-button>
        </el-form-item>
        <el-form-item label="电站类型" prop="stationType">
              <el-select v-model="stationInfo.stationType" placeholder="请选择电站类型" style="width: 100%;" filterable>
                <el-option v-for="item in stationTypeData" :key="item"
                  :label="item == 1 ? '公共设备' : item == 50 ? '个人专用' : item == 104 ? '内部专用' : item == 100 ? '公交专用' : item == 101 ? '环卫专用' : item == 102 ? '物流专用' : item == 103 ? '出租车专用' : item == 255 ? '其他' : ''"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="对外显示" prop="stationDisplay">
              <el-switch v-model="stationInfo.stationDisplay"
                :active-color="stationInfo.stationDisplay == false ? '#ff4949' : '#13ce66'"
                :inactive-color="stationInfo.stationDisplay == false ? '#ff4949' : '#13ce66'"></el-switch>
              <span style="color: red; margin-left: 20px;">(仅锐创合作小程序)</span>
            </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="经度" prop="longitude">
              <el-input disabled v-model="stationInfo.longitude" placeholder="请通过地图获取经度"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="stationInfo.contacts" placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="电站总功率" prop="totalPower">
              <el-input v-model="stationInfo.totalPower" placeholder="请输入电站总功率" style="width: 70%;"></el-input>
              （kWh）
            </el-form-item>
         <el-form-item label="离线充电" prop="brokenNet">
              <el-switch v-model="stationInfo.brokenNet" active-color="#13ce66"
                inactive-color="#ff4949"></el-switch>
              <span style="color: red; margin-left: 20px;">(仅支持直流充电桩)</span>
            </el-form-item>

            <el-form-item label="电站状态" prop="stationState">
              <el-select v-model="stationInfo.stationState" placeholder="请选择电站状态" style="width: 100%;" filterable>
                <el-option v-for="item in stateData" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="卡状态" prop="field">
              <el-select v-model="stationInfo.icState" placeholder="请选择电卡状态" style="width: 100%;" filterable>
                <el-option v-for="item in cardType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="latitude">
              <el-input disabled v-model="stationInfo.latitude" placeholder="请通过地图获取纬度"></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="contactsTel">
              <el-input v-model="stationInfo.contactsTel" placeholder="请输入电话号码"></el-input>
            </el-form-item>
            <el-form-item label="组织代码" prop="hlhtEquipmentOwnerId">
              <el-input v-model="stationInfo.hlhtEquipmentOwnerId" placeholder="请输入组织代码"></el-input>
            </el-form-item>
            <el-form-item label="离线充电量" prop="brokenNetCharging">
              <el-input-number v-model="stationInfo.brokenNetCharging" controls-position="right" :clearable="true"
                :min="0" style="width: 70%;"></el-input-number>
              （kWh）
            </el-form-item>
            <el-form-item label="他站费率显示" prop="feeModelDisplay">
              <el-switch v-model="stationInfo.feeModelDisplay"
                :active-color="stationInfo.feeModelDisplay == false ? '#ff4949' : '#13ce66'"
                :inactive-color="stationInfo.feeModelDisplay == false ? '#ff4949' : '#13ce66'"></el-switch>
            </el-form-item>

            <el-form-item label="营业时间" prop="field">
              <el-input placeholder="请输入场地信息" v-model="stationInfo.field"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="二维码" prop="parking">
              <el-radio-group v-model="stationInfo.qrCodeType" @change="qrCodeType_change">
                <el-radio v-for="(item, index) in radioMSK" :key="index" :label="item.qrCodeType">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
              <el-input placeholder="请输入停车信息" v-model="stationInfo.parking"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否开票" prop="isInvoice">
              <el-radio-group v-model="stationInfo.isInvoice" style="flex:1">
                <el-radio v-for="(item, index) in radioisInvoice" :key="index" :label="item.isInvoice">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="消费类型" prop="consumptionType">
              <el-select v-model="stationInfo.consumptionType" placeholder="请选择电站类型" style="width: 100%;"
                filterable>
                <el-option v-for="item in consumptionTypepeData" :key="item"
                  :label="item == 0 ? '全部允许' : item == 1 ? '仅绑定金额' : item == 2 ? '仅即充即退' : item == 3 ? '仅刷卡' : ''" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="停车类型" prop="parkType">
              <el-radio-group v-model="stationInfo.parkType" @change="parkType_change" style="flex:1">
                <el-radio v-for="(item, index) in radioparkType" :key="index" :label="item.parkType">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" v-if="stationInfo.parkType == 3">
            <el-form-item label="停车厂商" prop="parkModelId">
              <el-select v-model="stationInfo.parkModelId" placeholder="请选择停车厂商" filterable style="width: 100%;">
                <el-option v-for="item in carTypeData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="stationInfo.parkType == 3">
            <el-form-item label="车场编号" prop="outMcNo">
              <el-input v-model="stationInfo.outMcNo" placeholder="请输入车场编号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="stationInfo.parkType == 3">
          <el-col :span="12">
            <el-form-item label="减免方式" prop="derateType">
              <el-select v-model="stationInfo.derateType" placeholder="请选择减免方式" filterable style="width: 100%;"
                @change="jianmian">
                <el-option v-for="item in derateTypeData" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="stationInfo.derateType > 0">
            <el-form-item label="减免内容" prop="derateValue">
              <el-input v-model="stationInfo.derateValue"
                :placeholder="stationInfo.derateType == 1 ? '减免金额 （单位分）' : stationInfo.derateType == 2 ? '减免时长（单位分钟）' : '折扣（10代表1折 98代表98折）'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="停车信息" prop="parking">
          <el-input placeholder="请输入停车信息" v-model="stationInfo.parking"></el-input>
        </el-form-item>
        <el-form-item label="本站通知">
          <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="changeTimeall">
          </el-date-picker>
          <el-input placeholder="请输入本站通知" v-model="stationInfo.notice" style="margin-top: 20px;"></el-input>
        </el-form-item>
      </el-form>
</div>
<div class="center">
  <el-form :model="carInfo" ref="editFormRef" label-position="left">
          <!-- <el-row :gutter="20">
          <el-form-item label="费率类型：" style="margin-left: 20px;">
            <el-radio-group v-model="feeModelType">
              <el-radio v-for="(item, index) in testArray" :key="index" :label="item.id">
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row> -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="免费时长：" v-if="feeModelType == 0">
                <input v-model="carInfo.fixServiceFee" type="number" min="0.00" max="6.50" step="0.01" class="money1"
                  style="width: 80px;" />(分钟)
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="停车费率：">
                <input v-model="carInfo.fixFee" type="number" min="0.00" max="6.50" step="0.01" class="money1"
                  style="width: 80px;" />(元/分钟)
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="满足电量：">
                <input v-model="carInfo.billingPolicy" type="number" min="0.00" max="6.50" step="0.01" class="money1"
                  style="width: 80px;" />(度)
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="封顶金额：">
                <input v-model="carInfo.timeFeeModel" type="number" min="0.00" step="0.01" class="money1"
                  style="width: 80px;" />(元)
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>



        <el-form :model="MoneyInfo1" ref="editFormRef" label-width="100px" label-position="left">
        <el-form-item label="费率类型：">
          <el-radio-group v-model="MoneyInfo1.feeModelType" @change="tariffChange">
            <el-radio v-for="(item, index) in radioArray1" :key="index" :label="item.id">
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="费用配置:" v-if="MoneyInfo1.feeModelType==0">
            <el-row style="display: flex;flex-direction: row;justify-content: space-around;margin-top: -40px;">
              <el-col style="width:300px;margin-right: 20px;">
                <template>
                  <p style="display: flex;justify-content: center;">电费（元/度）</p>
                  <el-input-number placeholder="请输入电费" style="width: 90%;" v-model="MoneyInfo1.fixFee" :clearable="true"
                    :min="0" :max="6.5000" :step="0.01" :precision="4">
                  </el-input-number>
                </template>
</el-col>
<el-col style="width:300px;">
    <template>
                  <p style="display: flex;justify-content: center;">服务费（元/度）</p>
                  <el-input-number placeholder="请输入服务费" style="width: 90%;" v-model="MoneyInfo1.fixServiceFee"
                    :clearable="true" :min="0" :max="6.5000" :step="0.01" :precision="4">
                  </el-input-number>
                </template>
</el-col>
</el-row>
</el-form-item>
<el-form-item v-if="MoneyInfo1.feeModelType==1">
    <el-row>
        <el-col style='width: 420px;margin-top: -20px;display:flex;flex-direction:row;margin-left:-8%'>
            <span style="margin-right:10px;margin-bottom: -5px;width:250px;">全时服务费（元/度）</span>
            <el-input-number :clearable="true" :min="0" :max="6.5000" :step="0.01" style="width: 100%;" placeholder="请输入服务费" v-model="MoneyInfo1.fixServiceFee" placeholder-style="font-size:28rpx;color:#999999;" :precision="4"></el-input-number>
        </el-col>
    </el-row>
</el-form-item>
<el-form-item v-if="MoneyInfo1.feeModelType==2">
    <p style="color: red;margin-top:-20px;padding-bottom:10px;margin-left:-8%">* 注：此处仅设置无疆交流桩固定服务费，无疆交流桩暂不支持分时服务费。</p>
    <el-row>
        <el-col style='width: 420px;margin-top: -20px;display:flex;flex-direction:row;margin-left:-8%'>
            <span style="margin-top: -10px;margin-bottom: -5px;width:250px;"> 全时服务费（元/度）</span>
            <el-input-number style="width: 80%;" :clearable="true" :min="0" :max="6.5000" :step="0.01" placeholder="请输入服务费" v-model="MoneyInfo1.fixServiceFee" :precision="4"></el-input-number>
        </el-col>
    </el-row>
</el-form-item>
<el-form-item label="费用配置:" v-if="MoneyInfo1.feeModelType>0" style="width: 100%;
          display: flex;flex-direction: column;margin-top: -20px;">
    <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction: row;justify-content: space-between;align-items: center;" placeholder-style="font-size:28rpx;color:#999999">
        <el-col style="width:300px;margin-right: 5%;margin-top: -20px;">
            <template>
                  <p style="margin-left: 50%;">名称</p>
                  <el-input placeholder="尖时" :disabled="true" style="width: 100%;"></el-input>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;margin-top: -20px;"><template>
                  <p style="display: flex;justify-content: center;">电费（元/度）</p>
                  <el-input-number :clearable="true" :min="0" :max="6.5000" :step="0.01" style="width: 100%;"
                    placeholder="请输入电费" v-model="MoneyInfo1.billingPolicy.tip" :precision="4">
                  </el-input-number>
                </template>
        </el-col>
    </el-row>
    <br>
    <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction: row;justify-content: space-between;align-items: center;">
        <el-col style="width:300px;margin-right: 5%;"> <template>
                  <el-input placeholder="峰时" style="width: 100%;" :disabled="true"></el-input>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;"> <template>
                  <el-input-number :clearable="true" :min="0" :max="6.5000" :step="0.01" style="width: 100%;"
                    placeholder="请输入电费" v-model="MoneyInfo1.billingPolicy.peak" :precision="4">
                  </el-input-number>
                </template>
        </el-col>
    </el-row>
    <br>
    <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction: row;justify-content: space-between;align-items: center;">
        <el-col style="width:300px;margin-right: 5%;"> <template>
                  <el-input style="width: 100%;" placeholder="平时" :disabled="true"></el-input>
                </template>
        </el-col>
        <el-col style="width:300px;display: flex;
              flex-direction: column;margin-right: 5%;"><template>
                  <el-input-number :clearable="true" :min="0" :max="6.5000" :step="0.01" style="width: 100%;"
                    placeholder="请输入电费" v-model="MoneyInfo1.billingPolicy.flat" :precision="4">
                  </el-input-number>
                </template>
        </el-col>
    </el-row>
    <br>
    <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction: row;justify-content: space-between;align-items: center;">
        <el-col style="width:300px;margin-right: 5%;"><template>
                  <el-input style="width: 100%;" placeholder="谷时" :disabled="true"></el-input>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;"><template>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo1.billingPolicy.valley" :precision="4">
                  </el-input-number>
                </template>
        </el-col>
    </el-row>
</el-form-item>

<el-form-item label="费用配置" v-if="MoneyInfo1.feeModelType==2" style="width: 100%;margin-top: -20px;">
    <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction: row;justify-content: space-evenly;align-items: center;">
        <el-col style="width:300px;margin-right: 5%;margin-top: -20px;">
            <template>
                  <p style="display: flex;justify-content: center;">名称</p>
                  <el-input style="width: 100%;" placeholder="尖时" :disabled="true"></el-input>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;margin-top: -20px;">
            <template>
                  <p style="display: flex;justify-content: center;">电费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo1.billingPolicy.tip" :precision="4">
                  </el-input-number>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;margin-top: -20px;">
            <template>
                  <p style="display: flex;justify-content: center;">服务费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入服务费" v-model="MoneyInfo1.billingPolicy.tipService" :precision="4">
                  </el-input-number>
                </template>
        </el-col>
    </el-row>
    <br>
    <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction: row;justify-content: space-evenly;align-items: center;">
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>名称</p> -->
                  <el-input style="width: 100%;" placeholder="峰时" :disabled="true"></el-input>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>电费（元/度）</p> -->
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo1.billingPolicy.peak" :precision="4"></el-input-number>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>服务费（元/度）</p> -->
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入服务费" v-model="MoneyInfo1.billingPolicy.peakService"
                    :precision="4"></el-input-number>
                </template>
        </el-col>
    </el-row>
    <br>
    <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction:row;justify-content: space-evenly;align-items: center;">
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>名称</p> -->
                  <el-input style="width: 100%;" placeholder="平时" :disabled="true"></el-input>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>电费（元/度）</p> -->
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo1.billingPolicy.flat" :precision="4"></el-input-number>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>服务费（元/度）</p> -->
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入服务费" v-model="MoneyInfo1.billingPolicy.flatService"
                    :precision="4"></el-input-number>
                </template>
        </el-col>
    </el-row>
    <br>
    <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction:row;justify-content: space-evenly;align-items: center;">
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>名称</p> -->
                  <el-input style="width: 100%;" placeholder="谷时" :disabled="true"></el-input>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>电费（元/度）</p> -->
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo1.billingPolicy.valley" :precision="4"></el-input-number>
                </template>
        </el-col>
        <el-col style="width:300px;margin-right: 5%;">
            <template>
                  <!-- <p>服务费（元/度）</p> -->
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入服务费" v-model="MoneyInfo1.billingPolicy.valleyService"
                    :precision="4"></el-input-number>
                </template>
        </el-col>
    </el-row>
    <br>
</el-form-item>
<el-form-item label="费用配置:" v-if="MoneyInfo1.feeModelType>0">
    <div>
        <div v-for="(item, index) in timeList1" :key="index">
            <el-select v-model="item.type">
                <el-option v-for="item2 in options2" :key="item2" :value="item2"></el-option>
            </el-select>
            <el-select v-model="item.start" style="width: 20%;margin-left:10px">
                <el-option v-for="(timeItem, timeIndex) in timeListAll" :key="timeIndex" :label="timeItem" :value="timeItem" :disabled="getBeginSelect(timeIndex)" />
            </el-select>
            <span style="padding:0 10px ">-</span>
            <el-select v-model="item.end" style="width: 20%;" :disabled="!timeList1[index].start">
                <el-option v-for="(timeItem, timeIndex) in timeListAll" :key="timeIndex" :label="timeItem" :value="timeItem" :disabled="getEndSelect(timeItem, timeIndex, index)" />
            </el-select>
        </div>
        <el-button type="primary" @click="addNewRange" :disabled="canAddNew()">新增时间段</el-button>
    </div>
</el-form-item>
</el-form>

<!-- 低速费率 -->
<el-form :model="MoneyInfo2" ref="editFormRef" label-width="100px" label-position="left">
            <el-form-item label="费率类型：">
                <el-radio-group v-model="MoneyInfo2.feeModelType" @change="tariffChange2">
                    <el-radio v-for="(item, index) in radioArray2" :key="index" :label="item.id">
                        {{ item.name }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="固定费率：" v-if="MoneyInfo2.feeModelType == 3 || MoneyInfo2.feeModelType == 4">
                <span style="margin-right:20px;">电费</span><input v-model="MoneyInfo2.fixFee" type="number" min="0.00" max="6.50" step="0.01" style="width:10%;text-align: center;height:20px;border:1px solid #ccc" class="money1" />（元/小时）
                <span style="margin:0 20px;">服务费</span><input v-model="MoneyInfo2.fixServiceFee" type="number" min="0.00" max="6.50" step="0.01" style="width:10%;text-align: center;height:20px;border:1px solid #ccc" class="money1" />（元/小时）
            </el-form-item>
            <el-form-item label="时段费率：" v-if="MoneyInfo2.feeModelType ==2">
                <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction: row;justify-content: space-evenly;align-items: center;">
                    <el-col style="width:300px;margin-right: 5%;margin-top: -20px;">
                        <template>
                  <p style="display: flex;justify-content: center;">名称</p>
                  <el-input style="width: 100%;" placeholder="尖时" :disabled="true"></el-input>
                </template>
                    </el-col>
                    <el-col style="width:300px;margin-right: 5%;margin-top: -20px;">
                        <template>
                  <p style="display: flex;justify-content: center;">电费（元/度）</p>
                  <!-- {{MoneyInfo2.billingPolicy.tip}}--{{MoneyInfo2.billingPolicy.tipService}}--{{MoneyInfo2.billingPolicy.peak}}--{{MoneyInfo2.billingPolicy.peakService}}--{{MoneyInfo2.billingPolicy.flat}}--{{MoneyInfo2.billingPolicy.flatService}}--{{MoneyInfo2.billingPolicy.valley}}--{{MoneyInfo2.billingPolicy.valleyService}} -->
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo2.billingPolicy.tip" :precision="4">
                  </el-input-number>
                </template>
                    </el-col>
                    <el-col style="width:300px;margin-right: 5%;margin-top: -20px;">
                        <template>
                  <p style="display: flex;justify-content: center;">服务费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入服务费" v-model="MoneyInfo2.billingPolicy.tipService" :precision="4">
                  </el-input-number>
                </template>
                    </el-col>
                </el-row>
                <br>
                <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction: row;justify-content: space-evenly;align-items: center;">
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <p>名称</p>
                  <el-input style="width: 100%;" placeholder="峰时" :disabled="true"></el-input>
                </template>
                    </el-col>
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <p>电费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo2.billingPolicy.peak" :precision="4"></el-input-number>
                </template>
                    </el-col>
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <p>服务费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入服务费" v-model="MoneyInfo2.billingPolicy.peakService"
                    :precision="4"></el-input-number>
                </template>
                    </el-col>
                </el-row>
                <br>
                <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction:row;justify-content: space-evenly;align-items: center;">
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <!-- <p>名称</p> -->
                  <el-input style="width: 100%;" placeholder="平时" :disabled="true"></el-input>
                </template>
                    </el-col>
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <p>电费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo2.billingPolicy.flat" :precision="4"></el-input-number>
                </template>
                    </el-col>
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <p>服务费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入服务费" v-model="MoneyInfo2.billingPolicy.flatService"
                    :precision="4"></el-input-number>
                </template>
                    </el-col>
                </el-row>
                <br>
                <el-row style="flex: 1;display: flex;margin-top: -20px;flex-direction:row;justify-content: space-evenly;align-items: center;">
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <p>名称</p>
                  <el-input style="width: 100%;" placeholder="谷时" :disabled="true"></el-input>
                </template>
                    </el-col>
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <p>电费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入电费" v-model="MoneyInfo2.billingPolicy.valley" :precision="4"></el-input-number>
                </template>
                    </el-col>
                    <el-col style="width:300px;margin-right: 5%;">
                        <template>
                  <p>服务费（元/度）</p>
                  <el-input-number style="width: 100%;" :clearable="true" :min="0" :max="6.5000" :step="0.01"
                    placeholder="请输入服务费" v-model="MoneyInfo2.billingPolicy.valleyService"
                    :precision="4"></el-input-number>
                </template>
                    </el-col>
                </el-row>
                <br>
            </el-form-item>
            <el-divider v-if="MoneyInfo2.feeModelType == 4" content-position="center">每档位收费功率区间</el-divider>
            <el-form-item v-if="MoneyInfo2.feeModelType == 4">
                <div style="display: flex;flex-direction: row;justify-content: space-between;flex-wrap: wrap;width: 100%;margin-left:-40px;">
                    <li v-for="(item, index) in shuzu" :key="index" style="display:flex;flex-direction:row;justify-content:space-between;">
                        <span>{{ index + 1 + '、' }}</span>
                        <div style="display: flex;flex-direction: row;align-items: center;
                  border: 1px solid #DCDFE6;
                  font-size: 12px;margin:0 20px 20px 0;width:360px;">
                            <el-input-number v-model="item.name" @change="input_event1(index)" :min="0" :max="4000" style="margin-right: 10px;" step-strictly :controls="false">
                            </el-input-number>
                            <span>瓦</span><span style="color:#fff;
              width:80px;margin-left:10px;
              background:#409EFF;text-align:center">~</span>
                            <el-input-number v-model="item.keys" @change="input_event2(index)" :min="0" :max="4000" style="margin-right: 10px;" step-strictly :controls="false"></el-input-number>
                            <span>瓦</span>
                            <span style="color:#fff;
             width:100px;margin-left: 10px;
              background:#409EFF;text-align:center;">1小时</span>
                            <el-input-number v-model="item.value2" :min="0" :max="100" style="margin-right: 10px;" step-strictly :step="1" :controls="false"></el-input-number>
                            <span style="margin-right: 10px;">%</span>
                        </div>
                    </li>
                </div>
            </el-form-item>
            <el-divider v-if="MoneyInfo2.feeModelType == 4" content-position="center">收费说明</el-divider>
            <el-form-item label="费用配置:" v-if="MoneyInfo2.feeModelType == 2">
                <div>
                    <div v-for="(item, index) in timeList1" :key="index">
                        <el-select v-model="item.type">
                            <el-option v-for="item2 in options2" :key="item2" :value="item2"></el-option>
                        </el-select>
                        <el-select v-model="item.start" style="width: 20%;margin-left:10px;">
                            <el-option v-for="(timeItem, timeIndex) in timeListAll" :key="timeIndex" :label="timeItem" :value="timeItem" :disabled="getBeginSelect(timeIndex)" />
                        </el-select>
                        <span style="padding:0 10px ">-</span>
                        <el-select v-model="item.end" style="width: 20%;" :disabled="!timeList1[index].start">
                            <el-option v-for="(timeItem, timeIndex) in timeListAll" :key="timeIndex" :label="timeItem" :value="timeItem" :disabled="getEndSelect(timeItem, timeIndex, index)" />
                        </el-select>
                    </div>
                    <el-button type="primary" @click="addNewRange" :disabled="canAddNew()">新增时间段</el-button>
                </div>
            </el-form-item>
            <el-form-item v-if="MoneyInfo2.feeModelType == 4">
                <div style="display:flex;flex-direction:row;flex-wrap:wrap;
          width: 100%;margin-left:-40px;">
                    <p v-if="shuzu[0].value2 > 0" style="width:400px;margin-bottom:10px"><span v-if="shuzu[0].keys > 0" style="margin-right:10px;">1、&emsp;{{
      shuzu[0].name
    }}&emsp;~&emsp;{{ shuzu[0].keys }}瓦</span>
                        <span v-else>1、&emsp;{{ shuzu[0].name }}瓦&emsp;&emsp;以上&ensp;</span>
                        <span style="margin-right:10px;">电费:&emsp;
                  {{ jisuan(MoneyInfo2.fixFee, shuzu[0].value2, 2) }}&ensp;元</span><span style="margin-right:10px;">服务费:&emsp;{{
      jisuan(MoneyInfo2.fixServiceFee, shuzu[0].value2, 2) }}元</span>
                    </p>
                    <p v-if="shuzu[1].value2 > 0" style="width:400px;margin-bottom:10px;display:flex;justify-content:flex-end;">
                        <span style="margin-right:10px;" v-if="shuzu[1].keys > 0">2、&emsp;{{ shuzu[1].name }}&emsp;~&emsp;{{
      shuzu[1].keys
    }}瓦</span>
                        <span v-else>2、&emsp;{{ shuzu[1].name }}瓦&emsp;&emsp;以上&ensp;</span>
                        <span style="margin-right:10px;">电费:&emsp;
                  {{ jisuan(MoneyInfo2.fixFee, shuzu[1].value2, 2) }}
                  &ensp;元</span><span style="margin-right:10px;">服务费:&emsp;
                  {{ jisuan(MoneyInfo2.fixServiceFee, shuzu[1].value2, 2) }}
                  元</span>
                    </p>
                    <p v-if="shuzu[2].value2 > 0" style="width:400px;margin-bottom:10px"><span style="margin-right:10px;" v-if="shuzu[2].keys > 0">3、&emsp;{{
      shuzu[2].name
    }}&emsp;~&emsp;{{ shuzu[2].keys }}瓦</span>
                        <span v-else>3、&emsp;{{ shuzu[2].name }}瓦&emsp;&emsp;以上&ensp;</span>
                        <span style="margin-right:10px;">电费:&emsp;
                  {{ jisuan(MoneyInfo2.fixFee, shuzu[2].value2, 2) }}
                  &ensp;元</span><span style="margin-right:10px;">服务费:&emsp;
                  {{ jisuan(MoneyInfo2.fixServiceFee, shuzu[2].value2, 2) }}
                  元</span>
                    </p>
                    <p v-if="shuzu[3].value2 > 0" style="width:400px;margin-bottom:10px;display:flex;justify-content:flex-end;">
                        <span style="margin-right:10px;" v-if="shuzu[3].keys > 0">4、&emsp;{{ shuzu[3].name }}&emsp;~&emsp;{{
      shuzu[3].keys
    }}瓦</span>
                        <span v-else>4、&emsp;{{ shuzu[3].name }}瓦&emsp;&emsp;以上&ensp;</span>
                        <span style="margin-right:10px;">电费:&emsp;
                  {{ jisuan(MoneyInfo2.fixFee, shuzu[3].value2, 2) }}
                  &ensp;元</span><span style="margin-right:10px;">服务费:&emsp;
                  {{ jisuan(MoneyInfo2.fixServiceFee, shuzu[3].value2, 2) }}
                  元</span>
                    </p>
                    <p v-if="shuzu[4].value2 > 0" style="width:400px;margin-bottom:10px"><span style="margin-right:10px;" v-if="shuzu[4].keys > 0">5、&emsp;{{
      shuzu[4].name
    }}&emsp;~&emsp;{{ shuzu[4].keys }}瓦</span>
                        <span v-else>5、&emsp;{{ shuzu[4].name }}瓦&emsp;&emsp;以上&ensp;</span>
                        <span style="margin-right:10px;">电费:&emsp;
                  {{ jisuan(MoneyInfo2.fixFee, shuzu[4].value2, 2) }}&ensp;
                  元</span><span style="margin-right:10px;">服务费:&emsp;
                  {{ jisuan(MoneyInfo2.fixServiceFee, shuzu[4].value2, 2) }}
                  元</span>
                    </p>
                    <p v-if="shuzu[5].value2 > 0" style="width:400px;margin-bottom:10px;display:flex;justify-content:flex-end;">
                        <span style="margin-right:10px;" v-if="shuzu[5].keys > 0">6、&emsp;{{ shuzu[5].name }}&emsp;~&emsp;{{
      shuzu[5].keys
    }}瓦</span>
                        <span v-else>6、&emsp;{{ shuzu[5].name }}瓦&emsp;&emsp;以上&ensp;</span>
                        <span style="margin-right:10px;">电费:&emsp;
                  {{ jisuan(MoneyInfo2.fixFee, shuzu[5].value2, 2) }}
                  &ensp;元</span><span style="margin-right:10px;">服务费:&emsp;
                  {{ jisuan(MoneyInfo2.fixServiceFee, shuzu[5].value2, 2) }}
                  元</span>
                    </p>
                    <p v-if="shuzu[6].value2 > 0" style="width:400px;margin-bottom:10px"><span style="margin-right:10px;" v-if="shuzu[6].keys > 0">7、&emsp;{{
      shuzu[6].name
    }}&emsp;~&emsp;{{ shuzu[6].keys }}瓦</span>
                        <span v-else>7、&emsp;{{ shuzu[6].name }}瓦&emsp;&emsp;以上&ensp;</span>
                        <span style="margin-right:10px;">电费:&emsp;
                  {{ jisuan(MoneyInfo2.fixFee, shuzu[6].value2, 2) }}
                  &ensp;元</span><span style="margin-right:10px;">服务费:&emsp;
                  {{ jisuan(MoneyInfo2.fixServiceFee, shuzu[6].value2, 2) }}
                  元</span>
                    </p>
                    <p v-if="shuzu[7].value2 > 0" style="width:400px;margin-bottom:10px;display:flex;justify-content:flex-end;">
                        <span style="margin-right:10px;" v-if="shuzu[7].keys > 0">8、&emsp;{{ shuzu[7].name }}&emsp;~&emsp;{{
      shuzu[7].keys
    }}瓦</span>
                        <span v-else>8、&emsp;{{ shuzu[7].name }}瓦&emsp;&emsp;以上&ensp;</span>
                        <span style="margin-right:10px;">电费:&emsp;
                  {{ jisuan(MoneyInfo2.fixFee, shuzu[7].value2, 2) }}
                  &ensp;元</span><span style="margin-right:10px;">服务费:&emsp;
                  {{ jisuan(MoneyInfo2.fixServiceFee, shuzu[7].value2, 2) }}
                  元</span>
                    </p>
                </div>
            </el-form-item>
        </el-form>
</div>
<div class="bottom">
  <el-upload class="upload-demo" action="/api0/station-info/upLoadStationPicture" :on-change="handleChange"
        :file-list="fileList" :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">点击上传场站默认图片（单）</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="ok">确定上传图片（单）</el-button>
      </el-upload>
      <input v-if="imgg != null" type="image" :src="imgg" alt="" style="margin-top: 20px;margin-bottom: 20px;width: 100px;
    height: 100px;">
      <el-upload class="upload-demo" action="/api0/station-info/upLoadStationPictures" :file-list="newfilelist"
        :on-change="beforeChange" :auto-upload="false" list-type="picture" style="margin-top: 40px;">
        <el-button slot="trigger" size="small" type="primary">点击上传场站轮播图（多）</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" v-debounce="ok_succ">确定上传图片（多）</el-button>
      </el-upload>
      <li v-if="imgges != null" style="list-style: none;">
        <img :src="tupian + item" alt="" v-for="(item, index) in imgges" :key="index"
          style="width: 100px;height: 100px;margin:20px;">
      </li>
</div>
   </div>
</template>
<script>
export default {
   name: '',
   mixins: [],
   components: {

   },
   props: {

   },
   data() {
     return {

     }
   },
   computed: {

   },
   watch: {

   },
   mounted() {

   },
   methods: {
jianmian(){
  
}
   }
};
</script>

<style lang='less' scoped>
.alls{
  width:100%;
  height:100%;
  .top,.bottom{
    flex:4;
  }
  .center{
    flex:2;
  }
  .top,.bottom,.center{
    display:flex;
    flex-direction:column;
  }
}

</style>